export default __webpack_public_path__ + "images/assets/3b895c624f550a0c180c85567faf6342.svg";